module.exports = __webpack_public_path__ + "static/media/T1.920efb07.jpg";